var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { style: { height: "100%" } },
    [
      _c(
        "w-card",
        { style: { height: "100%", marginBottom: "100px", borderRadius: "0" } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "div",
                [
                  _c("w-input", {
                    style: { width: "100%" },
                    attrs: { fancy: "", label: _vm.$ct("new-conversation") },
                    on: {
                      keypress: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.addThread.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.thread.Title,
                      callback: function ($$v) {
                        _vm.$set(_vm.thread, "Title", $$v)
                      },
                      expression: "thread.Title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-list",
                _vm._l(_vm.sortedThreads, function (thisThread) {
                  return _c(
                    "w-list-item",
                    {
                      key: thisThread.ID,
                      on: {
                        click: function ($event) {
                          return _vm.open(thisThread.ID)
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            mousedown: function ($event) {
                              $event.stopPropagation()
                            },
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.complete(thisThread)
                            },
                          },
                        },
                        [
                          thisThread.Unread > 0
                            ? _c("span", { staticClass: "unread" }, [
                                _vm._v(_vm._s(thisThread.Unread)),
                              ])
                            : _vm._e(),
                          _c("w-fa", {
                            staticClass: "bttComplete",
                            class: { finished: thisThread.Closed },
                            attrs: {
                              size: "2x",
                              icon: ["far", "check-circle"],
                            },
                          }),
                        ],
                        1
                      ),
                      _c("w-fa", {
                        staticClass: "pin",
                        class: { pinned: thisThread.Pinned },
                        attrs: { icon: "thumbtack" },
                        on: {
                          mousedown: function ($event) {
                            $event.stopPropagation()
                          },
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.pin(thisThread)
                          },
                        },
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.thread.Title))]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }